import React, { useState, useEffect } from 'react';
import './ImageCarousel.css';
import { IoChevronBackOutline, IoChevronForward, IoCloseOutline } from 'react-icons/io5';
import { IoExpandOutline } from 'react-icons/io5';

function ImageCarousel({ slides, startIndex = 0, onSlideChange, onClose, onFullscreen }) {
  const [current, setCurrent] = useState(startIndex);
  const length = slides.length;

  useEffect(() => {
    if (startIndex >= 0 && startIndex < length) {
      setCurrent(startIndex);
    }
  }, [startIndex, length]);

  // her current değiştiğinde parent'a bildir
  useEffect(() => {
    onSlideChange?.(current);
  }, [current, onSlideChange]);

  if (length === 0) return null;

  const nextSlide = () => {
    if (length > 0) {
      setCurrent((c) => (c + 1) % length);
    }
  };
  
  const prevSlide = () => {
    if (length > 0) {
      setCurrent((c) => (c - 1 + length) % length);
    }
  };

  const handleFullscreen = () => {
    if (onFullscreen) {
      onFullscreen(slides[current], current);
    }
  };

  return (
    <div className="carousel">
      <button className="arrow arrow-left" onClick={prevSlide}>
        <IoChevronBackOutline />
      </button>
      <div className="slide">
        <img
          src={slides[current]}
          alt={`Slide ${current + 1}`}
          className="carousel-image"
        />
        {onClose && (
          <button 
            className="carousel-close-button"
            onClick={onClose}
          >
            <IoCloseOutline size={20} />
          </button>
        )}
      </div>
      <button className="arrow arrow-right" onClick={nextSlide}>
        <IoChevronForward />
      </button>
      {onFullscreen && (
        <button 
          className="carousel-fullscreen-button"
          onClick={handleFullscreen}
          title="View fullscreen"
        >
          <IoExpandOutline />
        </button>
      )}
    </div>
  );
}

export default ImageCarousel;
